<template>
    <canvas
        width="1000"
        height="1000"
        ref="canvas"
        class="qrcode-canvas"/>
</template>

<script>
 import Vue from 'vue';
 import Background from "./Background.vue"
 import { qrcanvas } from 'qrcanvas';

 import message from "ant-design-vue/lib/message";

 export default {
     name: 'RenderBoxQRCode',
     data() {
         return {
             images: []
         }
     },
     components: {
         Background
     },
     props: {
     },
     computed: {
     },
     mounted() {
         this.images = JSON.parse(sessionStorage.getItem("renderBoxQRCodeInfo"))

         this.downloadImages()
     },
     methods: {
         downloadImages() {
             var imageNumber = this.images.length

             for (var i = 0; i < this.images.length; i += 2) {
                 this.downloadImage(i + 1, this.images[i], this.images[i + 1])
             }

             message.success(imageNumber + " 张二维码下载完毕")
         },
         downloadImage(index, codeFirst, codeSecond) {
             var canvas = this.$refs.canvas.getContext("2d")

             canvas.fillStyle="#FFF";
             canvas.fillRect(0, 0, 1000, 1000);

             this.drawQrCode(canvas, index, codeFirst, 100, 80, 250, 430)
             this.drawQrCode(canvas, index + 1, codeSecond, 600, 80, 750, 430)

             this.drawQrCode(canvas, index, codeFirst, 100, 580, 250, 930)
             this.drawQrCode(canvas, index + 1, codeSecond, 600, 580, 750, 930)

             var imageName = (index + 1) / 2

             let link = document.createElement('a');
             link.href = this.$refs.canvas.toDataURL();
             link.setAttribute('download', imageName + '.png');
             link.style.display = 'none';
             document.body.appendChild(link);
             link.click();
         },
         drawQrCode(canvas, index, code, picX, picY, textX, textY) {
             var qrcodeCanvas = qrcanvas({
                 data: decodeURIComponent("https://machine.hibox.vip/" + code),
                 size: 300
             });

             canvas.drawImage(qrcodeCanvas, picX, picY)

             canvas.fillStyle="#000";
             canvas.font = '30px Arial'
             canvas.textAlign = "center";
             canvas.fillText("编号: " + index + "  [" + code.substring(0, 5) + "]", textX, textY)
         }
     },
 }
</script>

<style scoped>
</style>
